import React, { useState } from 'react';
import { Modal, Button, Spin, message, Typography } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

const DeleteWidgetModal = ({ show, onClose, onDelete }) => {
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    setDeleting(true); // Start the spinner
    try {
      await onDelete(); // Perform the delete action
      message.success('Widget successfully deleted!'); // Show success message
      onClose(); // Close the modal after successful deletion
    } catch (error) {
      message.error('Failed to delete widget'); // Show error message if deletion fails
    } finally {
      setDeleting(false); // Stop the spinner after deletion
    }
  };

  return (
    <Modal
      title="Delete Widget"
      visible={show}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose} disabled={deleting}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          danger
          onClick={handleDelete}
          disabled={deleting}
        >
          {deleting ? <Spin size="small" /> : 'Delete'}
        </Button>,
      ]}
      closable={!deleting}
      maskClosable={!deleting}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <ExclamationCircleOutlined style={{ color: '#faad14', fontSize: '24px', marginRight: '16px' }} />
        <Text>Are you sure you want to delete this widget?</Text>
      </div>
    </Modal>
  );
};

export default DeleteWidgetModal;
